import { render, staticRenderFns } from "./SpuModel.vue?vue&type=template&id=7ba16a48&scoped=true"
import script from "./SpuModel.vue?vue&type=script&lang=js"
export * from "./SpuModel.vue?vue&type=script&lang=js"
import style0 from "./SpuModel.vue?vue&type=style&index=0&id=7ba16a48&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7ba16a48",
  null
  
)

export default component.exports